export const articleStore = {
    state: {
        article: null,
        articles: null,
    },
    setArticles(articles) {
        this.state.articles = articles;
    },
};
